import log from 'loglevel'
import config from '../Constants'

log.setLevel(config.logLevel)

// Добавляем префикс с датой к логам
const originalFactory = log.methodFactory

log.methodFactory = function (methodName, logLevel, loggerName) {
    const rawMethod = originalFactory(methodName, logLevel, loggerName)

    return function (message, ...args) {
        const timestamp = new Date().toISOString()

        const prefix = loggerName
            ? `[${timestamp}] [${methodName.toUpperCase()}] [${String(loggerName)}]`
            : `[${timestamp}] [${methodName.toUpperCase()}]`

        rawMethod(`${prefix}: ${message}`, ...args)
    }
}

log.setDefaultLevel(log.getLevel())

// Фабрика для создания именованных логгеров
export function createLogger(name: string) {
    return log.getLogger(name)
}

// API для управления уровнями логирования
export const logConfig = {
    setLevel: (level: string) => {
        const logLevel = mapStringToLevel(level)

        if (logLevel !== undefined) {
            log.setLevel(logLevel)
            return true
        }

        return false
    },
    getLevel: () => {
        return mapLevelToString(log.getLevel())
    },
    resetLevel: () => {
        log.setLevel(config.logLevel)
    }
}

function mapStringToLevel(level: string): log.LogLevelNumbers | undefined {
    const levels: Record<string, log.LogLevelNumbers> = {
        'trace': log.levels.TRACE,
        'debug': log.levels.DEBUG,
        'info': log.levels.INFO,
        'warn': log.levels.WARN,
        'error': log.levels.ERROR
    }
    return levels[level.toLowerCase()]
}

function mapLevelToString(level: log.LogLevelNumbers): string {
    const levels: Record<number, string> = {
        [log.levels.TRACE]: 'trace',
        [log.levels.DEBUG]: 'debug',
        [log.levels.INFO]: 'info',
        [log.levels.WARN]: 'warn',
        [log.levels.ERROR]: 'error',
    }
    return levels[level] || 'unknown'
}

// Экспортируем основной логгер
export default log
